import { Button, MenuItem } from '@mui/material';
import { ActionsMenu } from '@tix-ticketing/ui-components';
import { SettingsIcon } from '@tix-ticketing/ui-icons/outline';
import { themePresets, type ThemePresetId } from 'lib/app-configs';
import { useThemeOverride } from 'lib/theme-config';
const presetIds = Object.keys(themePresets) as ThemePresetId[];
const presetLabels: Record<ThemePresetId, string> = {
  default: 'Fictional',
  alternative: 'Alternative',
  desingel: 'Desingel'
};

/** DEV-only: swaps a hardcoded preset in over the tenant's proxy theme. */
export function AppConfigSelector() {
  const [override, setOverride] = useThemeOverride();
  return <ActionsMenu button={<Button color="monochrome" startIcon={<SettingsIcon />} sx={() => ({
    display: {
      xs: 'none',
      md: 'inline-flex'
    },
    pl: 1.4,
    pr: 1.4,
    '.MuiButton-startIcon': {
      mr: 1.5,
      ml: 0
    }
  })}>
          Config
        </Button>}>
      <MenuItem selected={override === null} onClick={() => setOverride(null)}>
        Proxy (default)
      </MenuItem>
      {presetIds.map(id => <MenuItem key={id} selected={override === id} onClick={() => setOverride(id)}>
          {presetLabels[id]}
        </MenuItem>)}
    </ActionsMenu>;
}